/*
**************************** 
홈페이지 공지 리스트
*****************************
*/

import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function BoardList(props) {
    const navigate = useNavigate();

    const isFirst = useRef(false);
    const [noticeData, setNoticeData] = useState({ data: [], page: 0, totalCount: 0, listType: "list" });

    const requestSee = function (_index) {
        const reqSql = "/api/notice/request-see/" + _index;
        axios.get(reqSql).then(function (res) {

            if (res.status === 200) {
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }

        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }

    useEffect(() => {
        if (isFirst.current === false) {
            isFirst.current = true;
        } else {
            setNoticeData(props.detailData);
        }

        return () => {
            let copydata = [...noticeData.data];
            copydata = [];

            let copyNoticeData = { ...noticeData, data: copydata, totalCount: 0, listType: "list" };
            setNoticeData(copyNoticeData);
        };
    }, [props]);

    return (
        <div className="container">
            <div id="board-list">
                <table className="board-table">
                    <thead>
                        <tr>
                            <th scope="col" className="th-num">번호</th>
                            <th scope="col" className="th-title">제목</th>
                            <th scope="col" className="th-num">작성자</th>
                            <th scope="col" className="th-date">등록일</th>
                        </tr>
                    </thead>
                    <tbody>
                        {noticeData.data.map((cell, idx) => {
                            const dateMo = moment(cell.created_at).format('YYYY-MM-DD HH:mm');
                            return (
                                <tr key={cell.id} onClick={() => {
                                    requestSee(cell.id);

                                    navigate("/community/notice-detail/" + noticeData.page + "/" + cell.id + "/" + noticeData.listType);
                                }} style={{ cursor: "pointer" }} >
                                    <td>{cell.id}</td>
                                    <th >
                                        {cell.title}
                                        <p>{cell.content_msg}</p>
                                    </th>
                                    <td>{cell.writer}</td>
                                    <td>{dateMo}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}